import { Image } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import CellPhone from "../../images/cellPhone.png";

import localStorageKey from "../../../../enumerations/localStorageKey";
import styles from "./style.module.scss";
const StepsArea = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const localLang = window.localStorage.getItem(localStorageKey.DEFAULT_LANG);

  return (
    <div className={styles.stepsArea} id="homeStepArea">
      <div className={styles.mainText}>{t("home.simple.3steps")}</div>
      <div className={styles.subText}>{t("home.quick.setting")}</div>
      <div className={styles.phoneContainer}>
        <div className={styles.step}>
          <div className={styles.stepBubble}>
            <div className={styles.stepNum}>1</div>
            <div className={styles.bubbleText}>
              <div className={styles.stepTitle}>{t("home.steps.title.1")}</div>
              <div
                className={styles.stepDesc}
                dangerouslySetInnerHTML={{
                  __html: t("home.steps.desc.1"),
                }}
              />
            </div>
          </div>
          <div className={styles.phone}>
            <Image alt="phone" src={CellPhone} preview={false} />
            <img
              src={"/media/basic_step01.png"}
              alt="step1"
              className={styles.stepImg}
            />
          </div>
        </div>
        <div className={styles.step}>
          <div className={styles.stepBubble}>
            <div className={styles.stepNum}>2</div>
            <div className={styles.bubbleText}>
              <div className={styles.stepTitle}>{t("home.steps.title.2")}</div>
              <div
                className={styles.stepDesc}
                dangerouslySetInnerHTML={{
                  __html: t("home.steps.desc.2"),
                }}
              />
            </div>
          </div>
          <div className={styles.phone}>
            <Image alt="phone" src={CellPhone} preview={false} />
            <Image
              src={`/media/${localLang}/basic_step02.png`}
              fallback={"/media/basic_step02.png"}
              alt="step2"
              className={styles.stepImg}
              preview={false}
            />
          </div>
        </div>
        <div className={styles.step}>
          <div className={styles.stepBubble}>
            <div className={styles.stepNum}>3</div>
            <div className={styles.bubbleText}>
              <div className={styles.stepTitle}>{t("home.steps.title.3")}</div>
              <div
                className={styles.stepDesc}
                dangerouslySetInnerHTML={{
                  __html: t("home.steps.desc.3"),
                }}
              />
            </div>
          </div>
          <div className={styles.phone}>
            <Image alt="phone" src={CellPhone} preview={false} />
            <Image
              src={`/media/${localLang}/basic_step03.png`}
              fallback={"/media/basic_step03.png"}
              alt="step3"
              className={styles.stepImg}
              preview={false}
            />
          </div>
        </div>
      </div>
      <div
        className={styles.bottomBtn}
        onClick={() => {
          navigate("/installguide");
        }}
      >
        {t("hiddenStore.bottomStepBtn")}
      </div>
    </div>
  );
};

export default StepsArea;
